module.exports = __webpack_public_path__ + "static/media/ic_crown.005ab729.svg";